import {connect} from 'react-redux'
import AutomatView from "../../../components/views/liga/AutomatView";

const mapStateToProps = function (state, ownProps) {
    return {userId: state.user.id};
};

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomatView)